const dataUser = 
{
    "user": {
        "name": "",
        "lastName": "",
        "email": ""
    },
    "branchOffice": {
        "id": 11,
        "name": "",
        "ita": "",
        "printer": ""
    },
    "franchise": {
        "name": "",
        "bussinesName": "",
        "rfc": "",
        "legalAgent": ""
    },
    "modules": [
        {
            "modulo": "",
            "url": "",
            "cmsCode": ""
        }
    ]
}

export default dataUser;


// WEBPACK FOOTER //
// ./src/constants/userData.js